import React from 'react'
import { useSelector } from 'react-redux'
import { Navigate, useLocation } from 'react-router-dom'
import CenteredSpinner from 'components/CenteredSpinner'

const AuthGuard = ({ children }) => {
    const { isAuthenticated, initialized } = useSelector(state => state.auth)
    const location = useLocation()

    if (!initialized) {
        return <CenteredSpinner />
    }

    if (!isAuthenticated) {
        return <Navigate to="/login" state={{ from: location }} replace />
    }

    return children
}

export default AuthGuard
